/*
 *
 * Initial loader for rchat plugin.
 * 
 * Loads all core dependencies and desired modules.
 * 
 */
import 'babel-polyfill'
import $script from 'scriptjs'
import loadCSS, {onloadCSS} from './plugin/loadcss'

import config from './shared/config/dev'

let rchat = (window.rchat || {})

const mapScriptUrlsToPromise = (urls = []) => {
  return new Promise((resolve, reject) => {
    $script.order(urls, resolve, (depNotFound) => reject(`Could not load dependency: ${depNotFound}`))
  })
}

const mapStyleUrlToPromise = (url) => {
  if (!url) return Promise.reject(`Could not load style dependency. url field is empty`)

  return new Promise((resolve, reject) => {
    let ss = loadCSS(url)
    onloadCSS(ss, resolve)
  })
}

const mapStyleUrlsToPromise = (urls = []) => {
  return Promise.all(urls.map(mapStyleUrlToPromise))
}

const loadDeps = (deps) => {
  if (!deps || deps.length === 0) return Promise.reject('Could not load dependencies. config or config.dependencies object not found.')

  const scriptDeps = deps
    .filter((dep) => dep.type === 'script')
    .map((dep) => dep.url)

  const scriptDepsChain = mapScriptUrlsToPromise(scriptDeps)

  const styleDeps = deps
    .filter((dep) => dep.type === 'style')
    .map((dep) => dep.url)

  const styleDepsChain = mapStyleUrlsToPromise(styleDeps)

  return Promise.resolve(scriptDepsChain)
    .then(Promise.resolve(styleDepsChain))
}

const setDepConf = (conf = {}) => {
  if (conf.stripePublishableKey) Stripe.setPublishableKey(conf.stripePublishableKey);

  return Promise.resolve()
}

const setPluginConf = (conf = {}) => {
  rchat._conf = conf

  return Promise.resolve()
}

const resolveModulePaths = (modules = {}, loadingModules = []) => {
  let urls = []

  loadingModules.forEach((m) => {
    if (!modules[m] || !modules[m].paths) return

    modules[m].paths.forEach((p) => urls.push(p))
  })

  return urls
}

let readyCallbacks = []

rchat.ready = (cb) => {
  readyCallbacks.push(cb)
}

rchat.performReadyCallbacks = (cbs) => {
  if (cbs.length > 0) {
    cbs.forEach((cb) => cb())
  }
}

// TODO: change name to init after deleting old init logic.
rchat.init = (modules = [], conf = {}) => {
  if (!config) throw new Error('Could not find base plugin config.')
  if (!config.dependencies) throw new Error('Could not find config.dependencies.')
  if (!config.modules) throw new Error('Could not find module definitions.')
  if (modules.length < 1) throw new Error('You have provided no modules. Give an array as first argument like: rchat.init([\'ui\'], ...)')

  return setPluginConf(conf)
    .then(loadDeps.bind(null, config.dependencies))
    .then(setDepConf.bind(null, conf))
    .then(loadDeps.bind(null, resolveModulePaths(config.modules, modules)))
    .then(rchat.performReadyCallbacks.bind(null, readyCallbacks))
}

window.rchat = rchat


/** WEBPACK FOOTER **
 ** ./modules/rchat.js
 **/